// Used to prevent circle dependency.

export const musicPlayerHeight = '9rem';
export const musicPlayerHeightMinimized = '8rem';

// MusicPlayer's top border offset from screen bottom.
export const musicPlayerPosBottom = '9rem';
export const musicPlayerPosBottomMinimized = '11rem'; // (musicPlayerHeightMinimized + bottomOffset).
